// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosPromise } from 'axios';

import { CreditMethod, PaginationListResponse, SearchCondition } from '../types/Model';
import { LabReviewsResponse } from '../types/LabReviewsData';
import { authGet, authPost, authPut, parseCamelCase, parseSnakeCase } from './util';
import { ProductCard } from '../components/NewCard/types';

const baseURL = '/lab'

export const getLabInformation = (id: number, condition = 'Buy', workshopId?: number, iltCourseId?: number): AxiosPromise => {
  const query = workshopId ? `?workshopId=${workshopId}` : iltCourseId ? `?iltCourseId=${iltCourseId}` : `?condition=${condition}`;

  return authGet(`${baseURL}/labs/${id}/information${query}`, {
    withCredentials: true,
    transformResponse: (data: unknown) => {
      const parsed = parseCamelCase(data);

      if ('relatedWorkshop' in parsed) {
        const { startTime, endTime, ...workshop } = parsed.relatedWorkshop;
        return {
          ...parsed,
          relatedWorkshop: {
            ...workshop,
            startTime: new Date(startTime),
            endTime: new Date(endTime),
          }
        }
      }

      return parsed;
    }
  });
};

export const getLabReviews = (id: string, condition = 'Buy'): AxiosPromise => {
  return authGet(`${baseURL}/labs/${id}/reviews?condition=${condition}`, {
    transformResponse: (data: any) => {
      const parsed: LabReviewsResponse = {
        data: {
          averageRating: data.data.average_rating,
          canReview: data.data.can_review,
          review1: data.data.review1,
          review2: data.data.review2,
          review3: data.data.review3,
          review4: data.data.review4,
          review5: data.data.review5,
          reviewCount: data.data.review_count
        },
        list: data.list.map((review: any) =>
          ({
            comment: review.comment,
            username: review.username,
            reviewTime: review.review_time,
            userImageUrl: review.image_url,
            rating: review.rating
          })
        )
      }
      return parsed;
    }
  });
};

export const getLabRelated = (id: string): AxiosPromise => {
  return authGet(`${baseURL}/labs/${id}/related`, {
    transformResponse: (data: any) => {
      const parsed = data.map((data: any) => ({
        id: data.id,
        names: data.names,
        levelId: data.levelId,
        duration: data.available_duration,
        reviewAverage: parseInt(data.average_review, 10),
        reviewCount: data.review_count,
        costCredit: data.cost_credit,
        domainIds: data.domain_ids,
        imageUrl: data.image_url
      }));
      return parsed;
    }
  });
};

export const postLabReviews = (id: string, payload: any, condition = 'Buy'): AxiosPromise => {
  return authPost(`${baseURL}/labs/${id}/reviews?condition=${condition}`, payload)
};

export const buyLab = (id: number, test?: boolean, creditMethod?: CreditMethod, workshopId?: number, courseId?: number, iltCourseId?: number): AxiosPromise => {
  const query = workshopId ? `?workshopId=${workshopId}` : '';
  const courseQuery = courseId ? `?courseId=${courseId}` : '';
  const workshopQuery = iltCourseId ? `?iltCourseId=${iltCourseId}` : '';
  return authPost(`${baseURL}/labs/${id}/buy${query}${courseQuery}${workshopQuery}`, parseSnakeCase({
    test,
    creditMethod: creditMethod === CreditMethod.OrganizationCredit ? CreditMethod.OrganizationCredit: undefined
  }))
};

export const endLab = (id: number): AxiosPromise => {
  return authPost(`${baseURL}/labs/${id}/endLab`)
};

export const searchLabs = (limit: number, page: number, params: SearchCondition): AxiosPromise<PaginationListResponse<ProductCard>> => {
  return authPost(`${baseURL}/labs/search`, parseSnakeCase({
    limit,
    page,
    condition: 'labs',
    name: params.name || undefined,
    platformIds: params.platformId ? [params.platformId] : undefined,
    domainIds: params.domainIds.length > 0 ? params.domainIds : undefined,
    levelIds: params.levelId ? [params.levelId] : undefined,
  }), {
    transformResponse: (data: any) => parseCamelCase(data.result)
  });
};

export const searchLabsKeyword = (limit: number, name?: string): AxiosPromise => {
  return authPost(`${baseURL}/labs/keyword`, parseSnakeCase({
    limit: limit,
    name: name || undefined
  }), {
    transformResponse: (data: any) => parseCamelCase(data.result)
  });
};

export const sendVisitedLab = (id: number): AxiosPromise => {
  return authPut(`${baseURL}/labs/visitor/${id}`, {
    responseType: 'json'
  });
}
